<template>
<div>
    <div class="nav">
        <Row class="nav-content">
            <Col span="2">
                <div class="logo-img">
                    <img src="../assets/images/logo.png">
                </div>
            </Col>
            <Col span="2">
                玛丽云课堂
            </Col>
            <Col span="3" offset="14">
                <div class="create-btn hover" @click="btnFuc" v-if="btnText">
                    <i class="iconfont" :class="btnIcon"></i>
                    <span>{{btnText}}</span>
                </div>
            </Col>
            <Col span="2" class="hover personal-nav">
                <Row>
                    <Col span="20">
                        <div class="avatar-img">
                            <img :src="splitUrl(avatar)">
                        </div>
                    </Col>
                    <Col span="4">
                        <i class="iconfont iconxiala"></i>
                    </Col>
                </Row>
                <div class="avatar-list-box">
                    <div class="li">姓名：{{nickname}}</div>
                    <div class="li">ID: {{uid}}</div>
                    <div class="li" @click="logout">
                        <i class="iconfont icontuichudenglu"></i>
                        <span>退出登录</span>
                    </div>
                </div>
            </Col>
        </Row>
    </div>
    <Row class="head-content">
        <Col v-if="back" span="1">
            <i class="iconfont iconjiantouyoucopy hover" @click="goBack"></i>
        </Col>
        <Col span="2">
            {{title}}
        </Col>
    </Row>

   <div class="mask" v-if="isLogin">
       <div id="login_container">
           <iframe src="https://open.weixin.qq.com/connect/qrconnect?appid=wx7ce5b09150a68336&redirect_uri=https://api-class.bestmali.cn%2fsso%2fauth%2fwxLoginDo&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"></iframe>
       </div>
   </div>
</div>
</template>
<script>
export default {
    name:'Header',
    props:["title","btnIcon","btnText","back"],
    data(){
        return{
            isLogin:false
        }
    },
    created(){
        
    },
    activated(){
        let that = this
        if(this.$route.query.token){
            localStorage.setItem('token',this.$route.query.token)
        }
        // localStorage.setItem('token','eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjaWQiOjEsIm5pY2tuYW1lIjoiaGVoZTMzIiwib3BlbmlkIjoiMnNzZmdoMjQyIiwic2V4IjoxLCJ0b2tlbiI6IjE2NWQ3ZGI1ZDQyMTMxNDAwMGY2MmM4NjVkOGQwODA5IiwidWlkIjo4ODk3NH0.BBn0pVpxg5RBcqyuxxy6fra9TrNeViC_0321wiAXSdQ')
        let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
        if(token !== ''){
            if(this.$store.state.userData.id && this.$store.state.userData.audit_pass == 1){
                this.loginSuccess()
            }else{
                that.$post(that,{
                    url:'getUserInfo',
                    success(data){
                        if(data.audit_pass == -1){
                            that.openWindow('Audit')
                        }
                        that.$store.commit('changeUser',data)
                        that.loginSuccess()
                    }
                })
            }
        }else{
            this.isLogin = true
        }
    },
    components:{
        
    },
    methods:{
        loginSuccess(){
            setTimeout(()=>{
                this.$emit('loginSuccess')
            },200)
        },
        close(){
            this.isLogin = false
        },
        btnFuc(){
            this.$emit('btnFuc')
        },
        goBack(){
            this.$router.go(-1)
        },
        logout(){
            this.$store.commit('clearUser')
            localStorage.clear()
            this.isLogin = true
        }
    },
    computed:{
        avatar(){
            return this.$store.state.userData.avatar
        },
        nickname(){
            return this.$store.state.userData.nickname
        },
        uid(){
            return this.$store.state.userData.id
        }
    }
}
</script>
<style scoped>
.nav{
    width:100%;
    height: 80px;
    background: #363A45;
    font-size: 18px;
}
.nav-content{
    width:1200px;
    margin:0 auto;
    color:#fff;
    padding-top: 10px;
    line-height: 60px;
}
.nav-content .logo-img{
    width:60px;
    height: 60px;
    overflow: hidden;
    margin:0 auto;
}
.nav-content .create-btn{
    width:140px;
    height:30px;
    line-height: 30px;
    background: #5FBE96;
    border-radius:14px;
    margin-top: 15px;
}
.nav-content .create-btn .iconfont{
    font-size: 17px;
}
.nav-content .avatar-img{
    width:50px;
    height: 50px;
    border-radius: 50%;
    background: #999;
    margin:5px auto 0 auto;
    overflow: hidden;
}
.nav-content .avatar-img img{
    width: 100%;
    height: 100%;
}
.nav-content .personal-nav{
    position:absolute;
    right: 0;
    z-index: 9999;
}
.nav-content .personal-nav:hover{
   
}
.nav-content .personal-nav:hover .avatar-list-box{
    display: block;
}
.personal-nav .avatar-list-box{
    width:150%;
    display: none;
    background: #363A45;
    padding:10px;
}
.personal-nav .avatar-list-box .li{
    height: 30px;
    line-height: 30px;
    white-space: nowrap;
    width:100%;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
}
.personal-nav .avatar-list-box .icontuichudenglu{
    margin-right: 10px;
}
.head-content{
    width:1200px;
    margin:0 auto;
    line-height:45px;
    color: #fff;
    font-size: 18px;
}


.mask{
    width:100%;
    height: 100%;
    position:absolute;
    top: 0;
    padding-top: 40px;
    background: rgba(255,255,255,0.5);
    z-index: 9999;
}
.mask #login_container{
    height: 100%;
}
.mask #login_container iframe{
    height: 100%;
}
</style>

